import { call, put, takeLatest, all } from 'redux-saga/effects';
import api from '../../../utils/tt-api';
import Actions, { ActionTypes } from './actions';
import notification from '@tt/components/Notification';
import { CONSTANT_VARIABLES } from '../../../views/common/Constant_Variables/constants';

function* fetchAll({ toolParams }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    const { data } = yield call(api.get, {
      route: `Tool/GetSearched`,
      params: toolParams,
    });
    const allTool = data;
    yield put(Actions.setAll({ allTool }));
    yield put(Actions.setLoader({ showLoader: false }));
  } catch (err) {
    yield put(Actions.setLoader({ showLoader: false }));
    notification('error', err, '');
    console.warn(err); // Handle exception
  }
}
function* fetchToolsData() {
  try {
    yield put(Actions.setAllToolsDataLoader({ allToolsDataLoader: true }));
    const { data } = yield call(api.get, {
      route: `Tool`,
    });
    const toolsData = data;
    yield put(Actions.setToolsData({ toolsData }));
    yield put(Actions.setAllToolsDataLoader({ allToolsDataLoader: false }));
  } catch (err) {
    yield put(Actions.setAllToolsDataLoader({ allToolsDataLoader: false }));
    notification('error', err, '');
    console.warn(err); // Handle exception
  }
}

// export complete tool data in csv
function* toolDataExport() {
  try {
    yield put(Actions.toolDataExportLoader({ toolExportLoader: true }));
    const { data } = yield call(api.get, {
      route: 'Tool/GetAllCSVData',
    });
    const toolExportData = data;
    yield put(Actions.setToolDataExport({ toolExportData }));
    yield put(Actions.toolDataExportLoader({ toolExportLoader: false }));
    notification('success', CONSTANT_VARIABLES.FILE_DOWNLOADED_SUCCESSFULLY, '');
  } catch (error) {
    notification('error', error, '');
    console.warn(error); // Handle exception
  }
}
// export tools by factory name
function* toolExportByFactoryName({ toolExportParams }) {
  try {
    yield put(Actions.setToolExportFactoryLoader({ toolExportByFactoryLoader: true }));
    const { data } = yield call(api.get, {
      route: 'Tool/ExportTools',
      params: toolExportParams,
    });
    const toolExportByFactoryNameData = data;
    yield put(Actions.setToolExportFactoryData({ toolExportByFactoryNameData }));
    yield put(Actions.setToolExportFactoryLoader({ toolExportByFactoryLoader: false }));
    notification('success', CONSTANT_VARIABLES.FILE_DOWNLOADED_SUCCESSFULLY, '');
  } catch (error) {
    notification('error', error, '');
    console.warn(error); // Handle exception
  }
}

function* fetchToolById({ toolId }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    const { data } = yield call(api.get, {
      route: `Tool/${toolId}`,
    });
    const tool = data;
    yield put(Actions.setToolById({ tool }));
    yield put(Actions.setLoader({ showLoader: false }));
  } catch (err) {
    yield put(Actions.setLoader({ showLoader: false }));
    notification('error', err, '');
    console.warn(err); // Handle exception
  }
}

function* addorUpdateTool({ toolData, actionName, toolParams }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    yield call(actionName === 'Update' ? api.put : api.post, {
      route: `Tool`,
      data: toolData,
    });
    yield put(Actions.fetchAll({ toolParams }));
    notification(
      'success',
      actionName === CONSTANT_VARIABLES.ADD ? CONSTANT_VARIABLES.TOOL_CREATED : CONSTANT_VARIABLES.TOOL_UPDATED,
      ''
    );
  } catch (err) {
    yield put(Actions.setLoader({ showLoader: false }));
    notification('error', err.toString(), '');
    console.warn(err); // Handle exception
  }
}

function* deleteTool({ id, toolParams }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    yield call(api.delete, {
      route: `Tool/${id}`,
    });
    yield put(Actions.fetchAll({ toolParams }));
    notification('success', CONSTANT_VARIABLES.TOOL_DELETED, '');
  } catch (err) {
    yield put(Actions.setLoader({ showLoader: false }));
    notification('error', err.toString(), '');
    console.warn(err); // Handle exception
  }
}

function* fetchToolByFactoryId({ factoryId }) {
  try {
    yield put(Actions.setAllToolsDataLoader({ allToolsDataLoader: true }));
    const { data } = yield call(api.get, {
      route: `Tool/gettoolsbyfactory/${factoryId}`,
    });
    const getToolDataByFactoryId = data;
    yield put(Actions.setToolByFactoryId({ getToolDataByFactoryId }));
    yield put(Actions.setAllToolsDataLoader({ allToolsDataLoader: false }));
  } catch (err) {
    yield put(Actions.setAllToolsDataLoader({ allToolsDataLoader: false }));
    notification('error', err, '');
    console.warn(err); // Handle exception
  }
}

function* isToolDeletable({ toolId }) {
  try {
    yield put(Actions.setToolDeletableLoader({ toolDeletableLoader: true }));
    const { data } = yield call(api.get, {
      route: `tool/istooldeletable/${toolId}`,
    });
    const toolDeletable = data;
    yield put(Actions.setToolDeletable({ toolDeletable }));
    yield put(Actions.setToolDeletableLoader({ toolDeletableLoader: false }));
  } catch (err) {
    yield put(Actions.setToolDeletableLoader({ toolDeletableLoader: false }));
    notification('error', err, '');
    console.warn(err); // Handle exception
  }
}

function* importExcelToolFile({ importFileParams, toolParams }) {
  try {
    yield put(Actions.setImportExcelToolFileLoader({ importExcelFileLoader: true }));
    const { data } = yield call(api.post, {
      route: 'tool/postToolfile/' + importFileParams.factoryId,
      data: importFileParams.file,
    });
    const importToolFile = data;
    yield put(Actions.setImportExcelToolFile({ importToolFile }));
    yield put(Actions.setImportExcelToolFileLoader({ importExcelFileLoader: false }));
    yield put(Actions.fetchAll({ toolParams }));
  } catch (error) {
    notification('error', error, '');
    yield put(Actions.setImportExcelToolFileLoader({ importExcelFileLoader: false }));
    console.warn(error); // Handle exception
  }
}

export default function* rootSaga() {
  yield all([
    takeLatest(ActionTypes.FETCH_ALL, fetchAll),
    takeLatest(ActionTypes.TOOL_EXPORT_BY_FACTORY_NAME, toolExportByFactoryName),
    takeLatest(ActionTypes.FETCH_TOOLS_DATA, fetchToolsData),
    takeLatest(ActionTypes.FETCH_TOOL_BY_ID, fetchToolById),
    takeLatest(ActionTypes.ADD_OR_UPDATE_TOOL, addorUpdateTool),
    takeLatest(ActionTypes.EXPORT_TOOL_DATA, toolDataExport),
    takeLatest(ActionTypes.DELETE_TOOL, deleteTool),
    takeLatest(ActionTypes.FETCH_TOOLS_BY_FACTORYID, fetchToolByFactoryId),
    takeLatest(ActionTypes.IS_TOOL_DELETABLE, isToolDeletable),
    takeLatest(ActionTypes.TOOL_IMPORT, importExcelToolFile),
  ]);
}
